import React from 'react';
import withIcon from '../utilities/withIcon';

const IconWrench = () => {
  return (
    <g>
      <path d="m15.353 2.6743a.7.7 0 0 0 -1.1206-.1807l-2.1055 2.1055-.7269-.7265 2.1055-2.1055a.7.7 0 0 0 -.1807-1.12 4.56 4.56 0 0 0 -6.35 5.6708l-3.8757 3.8759c-.0138.0139-.0187.0322-.0311.0469a2.8047 2.8047 0 1 0 1.8793 4.7861 2.7957 2.7957 0 0 0 .8112-2.0949c.0146-.0124.033-.0173.0468-.0311l3.8758-3.8758a4.5673 4.5673 0 0 0 5.6719-6.3507zm-11.3955 11.3623a1.4092 1.4092 0 1 1 0-1.9941 1.4134 1.4134 0 0 1 0 1.9941zm1.3165-2.5846a2.8 2.8 0 0 0 -.3262-.4 2.7973 2.7973 0 0 0 -.4-.3266l3.148-3.1484a4.5956 4.5956 0 0 0 .3277.3988 4.6 4.6 0 0 0 .3985.3276zm8.25-4.4662a3.2659 3.2659 0 0 1 -4.5107 0 3.1768 3.1768 0 0 1 2.6938-5.4l-1.792 1.792a.7.7 0 0 0 0 .99l1.7163 1.7168a.7.7 0 0 0 .99 0l1.7925-1.793a3.16 3.16 0 0 1 -.8895 2.6942z" />
    </g>
  );
};

export default withIcon(IconWrench);
